module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--2--redeem-4eea320e.png";